import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Banners Order',
  basePath: '/banners-order',
  reorderable: true,
  columns: [
    { key: 'orderby', label: 'Order' },
    { key: 'banners_type_name', label: 'Type' },
    { key: 'banner_title', label: 'Title' },
    { key: 'banner_price', label: 'Price' },
  ],
  fields: [
    { key: 'banners_type', label: 'Banners type', type: 'async-select',
      optionsUrl: '/banner-types/options',
      placeholder: 'Select type', required: true },
    { key: 'banners_id', label: 'Banner', type: 'async-select',
      optionsUrl: '/banners/options',
      dependsOn: ['banners_type'],
      valuesParams: { banners_type: 'banners_type' },
      visible: (v) => !!v.banners_type,
      placeholder: 'Select banner' },
  ],
  filters: [
    { key: 'bannersType', label: 'Type', type: 'select',
      optionsUrl: '/banner-types/options' },
  ],
});
